<template>
  <!-- TableListPage.vue 에 사용하는 검색 폼 -->
  <search-nav ref="searchNavigation" :layout="layout" :useReset="useReset" @handleSearch="onClickSearch" @resetSearch="onClickReset">
    <template #default="{ filter, setRef }">
      <slot :setRef="setRef">
        <component
          v-for="(component, index) in stdSearchComponents" :key="component.value"
          v-if="showSearchNavItem(component['options'])"
          :setRef="setRef"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="{nav: componentValues, layout, ...component['options']}"
          :onClickSearch="onClickSearch"
          v-model="componentValues[component['value']]"
        />
      </slot>
    </template>
  </search-nav>
</template>

<script>
import singlePageList from "@/views/boards/single-page/listIndex";
import searchComponent from "@/views/list/components/include";
import SearchNav from "@/components/nav/SearchNav.vue";

export default {
  name: "SearchTools",
  components: {SearchNav},
  props: {
    value: [Object, String, Number, Array, Boolean],
    boardId: [String, Number],
    layout: String,
    useReset: Boolean, // [검색] 버튼 왼편에 [초기화] 버튼 노출 여부
    options: Array, // [{ label: '', options: {} }], List.js 에서 사용한 components 내부의 label 을 key 로 options 병합
  },
  computed: {
    getBoardId() {
      return this.boardId || this.$route.params.boardId;
    },
    componentValues: {
      set(value) {
        this.$emit("input", value);
      },
      get() {
        return this.value;
      },
    },
    stdSearchComponents() {
      if (singlePageList[`${this.getBoardId}_list`]) {
        const getComponents = singlePageList[`${this.getBoardId}_list`].components;
        if (getComponents) {
          const stdSearchComponents = getComponents();
          if (stdSearchComponents && stdSearchComponents.length > 0) {
            for (const component of stdSearchComponents) {
              // 임의의 boardId 를 사용할 경우, 해당 boardId 를 사용하도록 설정
              if (component["component"] === 'search-column-keyword') {
                component.options.boardId = this.getBoardId;
              }
              // options 병합
              if (this.options && this.options.length > 0) {
                this.options.forEach(opt => {
                  if (opt.label === component.label) {
                    component['options'] = {
                      ...component['options'],
                      ...opt.options,
                      updateSearchTools: true // options 병합 후, 자식 컴포넌트에서 감지할 수 있도록 true 로 설정
                    };
                  }
                })
              }
              component.component = searchComponent[component["component"]];
            }
          }
          return stdSearchComponents;
        }
      }
      return [];
    },
  },

  data () {
    return {

    }
  },

  methods: {
    // 검색 컴포넌트를 보여줄지 여부 결정
    // radio, select 등의 컴포넌트로 "A" 선택시 A 컴포넌트를 보여주고, "B" 선택시 B 컴포넌트를 보여주는 경우 사용
    showSearchNavItem(options) {
      // 관리자(superuser) 에게만 노출되는 검색 컴포넌트
      if (options && options.visibleAdminOnly) {
        const myInfo = this.$store.state.auth.userInfo;
        if (!(myInfo && parseInt(myInfo.is_superuser) > 0)) {
          return false;
        }
      }
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },

    // dotted path 를 통해서 json 데이터를 찾는다
    // ex> findJsonDataWithDottedPath({a: {b: {c: 1}}}, 'a.b.c') => 1
    findJsonDataWithDottedPath(json, path) {
      try {
        const _keys = Object.keys(json);
        if (_keys.length === 0) {
          return "";
        }
        const paths = path.split(".");
        let result = json;
        for (const p of paths) {
          result = result[p];
        }
        return result;
      } catch (err) {
        return "";
      }
    },

    // 검색 버튼 클릭시
    // this.componentValues 는 computed 로 인해 자동으로 업데이트 되어있으나,
    // [검색] 버튼을 클릭 event 가 발생했다는 의미로 emit 한다
    onClickSearch() {
      this.$emit("search", this.componentValues);
    },

    // [초기화] 버튼 클릭시. 검색조건 초기화는 사용하는 쪽에서 처리한다
    onClickReset() {
      this.$emit("resetSearch", this.componentValues);
    },
  }
}
</script>

<style scoped>

</style>
